import { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "../../qg-components/src/libs/Dropdown";
export default function Language() {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.language);
  const languageList = useMemo(() => {
    return [
      { language: "简体中文", value: "zh" },
      { language: "English", value: "en" },
    ]
  }, []);
  // change language 时，显示语言文本
  const lang = useMemo(() => {
    const currentLang = (languageList.filter(item => item.value === language))[0]
    return currentLang.language;
  }, [language, languageList]);

  // change language
  const handleChangeLanguage = (lang) => {
    dispatch({ type: "SET_LANGUAGE", value: lang.value });
  };
  return (
    <Dropdown icon className="mr-4" button={lang}>
      <ul className="py-1 inline-block whitespace-nowrap ">
        {
          languageList.map((langItem) => (
            <li
              key={langItem.value}
              className="text-sm hover:bg-gray-100 text-gray-700 px-4 py-2 cursor-pointer"
              onClick={() => handleChangeLanguage(langItem)}
            >
              {langItem.language}
            </li>
          ))
        }
      </ul>
    </Dropdown>
  );
} 
